import { useState, useEffect, useCallback } from 'react';
import {
  clearAnalyticsEvents,
  sendViewPromotionAnalyticsEvent,
} from '../helpers/analitycs';
import { collectionItemType } from '../types';

interface InViewAnalytics {
  campaigns: collectionItemType[];
  title: string;
  isInView: boolean;
}

const useInViewAnalytics = ({
  campaigns,
  title,
  isInView,
}: InViewAnalytics) => {
  const [visibleItems, setVisibleItems] = useState<collectionItemType[]>([]);
  const [itemsAlreadySent, setItemsAlreadySent] = useState<
    collectionItemType[]
  >([]);

  useEffect(() => {
    if (!isInView || visibleItems.length === 0) return;
    const itemsToSend = visibleItems.filter(
      (item) => !itemsAlreadySent.includes(item),
    );
    if (itemsToSend.length === 0) return;

    const items = itemsToSend.map((item) => ({
      name: item.name,
      index: campaigns.indexOf(item),
    }));

    const delay = 400; // wait items to be visible

    const timer = setTimeout(() => {
      clearAnalyticsEvents({ ecommerce: null }).then(() => {
        sendViewPromotionAnalyticsEvent({
          collectionName: title,
          items,
        });
        setItemsAlreadySent((prev) => [...prev, ...itemsToSend]);
      });
    }, delay);

    return () => clearTimeout(timer);
  }, [isInView, title, visibleItems, itemsAlreadySent]);

  const handleInViewChange = useCallback(
    (campaign: collectionItemType, isInView: boolean) => {
      setVisibleItems((prev) => {
        if (isInView) {
          return [...prev, campaign];
        } else {
          return prev.filter((item) => item._id !== campaign._id);
        }
      });

      setItemsAlreadySent((prev) => {
        if (!isInView) {
          return prev.filter((item) => item._id !== campaign._id);
        } else {
          return prev;
        }
      });
    },
    [],
  );

  return { handleInViewChange };
};

export default useInViewAnalytics;
